import React from 'react'
import { Add } from "@material-ui/icons"
import {
    Fab,
    makeStyles,
} from "@material-ui/core";
import theme from "js/material-ui-theme"

interface IButtonMobileAddProps {
    onNew: () => void
}

export function ButtonMobileAdd(props: IButtonMobileAddProps) {
    const styles = useStyles();
    return (
        <Fab
            size="medium"
            color="primary"
            aria-label="add"
            className={styles.fab}
            onClick={() => {
                props.onNew();
            }}
        >
            <Add />
        </Fab>
    )
}

const useStyles = makeStyles(() => ({
    fab: {
        position: "fixed",
        margin: "0px",
        top: "auto",
        left: "auto",
        right: theme.spacing(3),
        bottom: theme.spacing(3),
        zIndex: 1,
    }
}));
